import {gql} from '@apollo/client';

export const GET_TEAM_INTERACTIONS_SUMMARY = gql`
  query GetAdminInteractionSummary($filter: InterActionSummaryFilter!) {
    getAdminInteractionSummary(filter: $filter) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithInteractionSummary {
        data {
          statistics {
            totalInteractions
            totalKycCompleted
            totalSuccessfulDeposits
            totalSuccessfulInvestment
            totalDabaProSold
          }
          summary {
            user {
              firstName
              lastName
              email
              id
            }
            totalInteraction
            lastInteraction
          }
        }
        pagination {
          total
        }
      }
    }
  }
`;

export const GET_ALL_TEAM_INTERACTIONS = gql`
  query GetCumulativeInteractionSummary($filter: InterActionSummaryFilter!) {
    getCumulativeInteractionSummary(filter: $filter) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithInteractionSummary {
        data {
          statistics {
            totalInteractions
            totalKycCompleted
            totalSuccessfulDeposits
            totalSuccessfulInvestment
            totalDabaProSold
          }
          summary {
            user {
              firstName
              lastName
              email
              id
            }
            totalInteraction
            lastInteraction
          }
        }
        pagination {
          total
        }
      }
    }
  }
`;

export const GET_CUSTOMERS_CALL_LIST = gql`
  query GetCustomerCallList($filters: CustomerCallListFilters) {
    getCustomerCallList(filters: $filters) {
      ... on Error {
        message
        statusCode
      }
      ... on ResponseWithCustomerCallList {
        message
        pagination {
          total
        }
        data {
          id

          totalPortfolioValue
          totalReturns
          hasLosses
          currency
          portfolioPercentageChange
          userSegments {
            name
            description
          }
          totalInvestmentsLast30Days
          totalInvestments
          lastInvestmentDate
          totalWalletBalance
          recentSignificantWithdrawals
          hasRecentInvestments
          hasInvestedInBondsOrManagedFunds
          totalBonds
          totalManagedFunds
          totalStocks
          totalVentureFunds
          investedAssetClasses
          dabaProStatus
          priority
          callReasons
          user {
            id
            firstName
            lastName
            email
          }
          customerSuccessAgent {
            email
            firstName
            lastName
          }
          investorProfile
        }
      }
    }
  }
`;
